import type { SubjectTypeDefinitionPayload } from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionsFetched';

export type SubjectTypeDefinitionSavedAction = {
	type: 'SUBJECT_TYPE_DEFINITION_SAVED';
	payload: SubjectTypeDefinitionPayload;
	accountId: number;
};

export default (
	payload: SubjectTypeDefinitionPayload,
	accountId: number,
): SubjectTypeDefinitionSavedAction => ({
	type: 'SUBJECT_TYPE_DEFINITION_SAVED',
	payload,
	accountId,
});
